import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Scene3D from "./three/Scene3D";
import Cursor from "./components/Cursor";
import Navbar from "./components/Navbar";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import HowItWorks from "./sections/Variants";
import Specs from "./sections/Specs";
import Buy from "./sections/Waitlist";
import Marquee from "./sections/Marquee";
import Footer from "./sections/Footer";
import LegalPage from "./components/LegalPage";

const Landing = () => {
  // Smooth scroll
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
    // Lenis must be initialised exactly once for the lifetime of the page.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToBuy = () => {
    document.getElementById("comprar")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App noise relative">
      {/* Fixed 3D ambient scene in the background */}
      <Scene3D />

      {/* Custom cursor */}
      <Cursor />

      {/* Foreground content */}
      <div className="relative z-10">
        <Navbar onBuyClick={scrollToBuy} />
        <Hero onCTAClick={scrollToBuy} />
        <Marquee />
        <Features />
        <HowItWorks />
        <Specs />
        <Buy />
        <Footer />
      </div>

      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            backdropFilter: "blur(20px)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/legal" element={<LegalPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
